import { render, staticRenderFns } from "./ClientFiles.vue?vue&type=template&id=630f6326&"
import script from "./ClientFiles.vue?vue&type=script&lang=ts&"
export * from "./ClientFiles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports